import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import './swagger-dark.css';
import type { OpenApiDocument } from '@/utils/endpointToOpenApi';

interface SwaggerUiViewProps {
  spec: OpenApiDocument;
}

/**
 * Renders an OpenAPI document with the Swagger UI library (swagger-ui-react,
 * React 19-compatible as of 5.32.x). Fed the in-memory `spec` object — no URL
 * fetch — so it always reflects the current endpoint. Wrapped in `.swagger-dark`
 * so the scoped dark overrides in `swagger-dark.css` match the app chrome.
 */
export function SwaggerUiView({ spec }: SwaggerUiViewProps) {
  return (
    <div className="swagger-dark">
      <SwaggerUI spec={spec} docExpansion="full" tryItOutEnabled />
    </div>
  );
}
